import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'has_fac_conducted_assessment_identify_equip_contains_pcb'

export const dataPointDefinition = {
  retracedId: 'has_fac_conducted_assessment_identify_equip_contains_pcb',
  name: 'Has the facility conducted an assessment to identify if equipment contains PCB?',
  description:
    'PCBs are synthetic chlorinated hydrocarbon compounds, and have been used in plasticizers, surface coatings, inks, adhesives, flame retardants, pesticide extenders, paints, and microencapsulation of dyes for carbonless duplicating paper. Humans may be exposed to PCBs by inhaling contaminated air and ',
  meta: {
    slcpMeta: {
      key: 'hs-bui-12',
      number: 'HS-BUI-14',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-12', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29460,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
